<template>
  <v-data-table
    :headers="headers"
    :items="topVoting"
    disable-initial-sort
    :total-items="localPagination.totalItems"
    :pagination.sync="localPagination"
    :rows-per-page-items="[5, 10]"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.score }}</td>
      <td>
        <v-chip v-if="props.item.typeEventName" small color="transparent">
          <v-avatar v-if="props.item.typeEventIcon" size="32">
            <img :src="props.item.typeEventIcon" alt />
          </v-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              {{ props.item.typeEventName }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-chip>
      </td>
      <td>
        <v-chip v-if="props.item.teamName" small color="transparent">
          <v-avatar v-if="props.item.entityIcon" size="32">
            <img :src="props.item.entityIcon" alt />
          </v-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              {{ props.item.teamName }}
            </v-list-tile-title>
            <v-list-tile-sub-title
              v-if="props.item.teamCategory && props.item.teamCategory.length"
              class="caption primary--text text--lighten-1 text-truncate"
            >
              {{ props.item.teamCategory.join(' - ') }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-chip>
      </td>
      <td>
        <v-chip v-if="props.item.playerName" small color="transparent">
          <v-avatar v-if="props.item.playerPhoto" size="32">
            <img :src="props.item.playerPhoto" alt />
          </v-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              {{ props.item.playerName }}
            </v-list-tile-title>
            <v-list-tile-sub-title
              v-if="props.item.dorsal"
              class="caption primary--text text--lighten-1 text-truncate"
            >
              {{ `${$t('fields.global.dorsal')}: ${props.item.dorsal}` }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-chip>
        <span v-else>--</span>
      </td>
      <td>{{ props.item.rate }}</td>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TopVotingList',
  props: {
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    pagination: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      topVoting: (state) => state.stats.topVoting,
    }),
    headers() {
      return [
        {
          text: this.$t('titles.global.votes'),
          sortable: false,
        },

        {
          text: this.$tc('models.typeEvent'),
          sortable: false,
        },
        {
          text: this.$tc('models.team'),
          sortable: false,
        },
        {
          text: this.$tc('titles.global.player'),
          sortable: false,
        },
        {
          text: this.$t('titles.global.rate'),
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$emit('update:pagination', value)
      },
    },
  },
}
</script>
